import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getShipmentCreatedBy } from '../../../redux/shipment/ShipmentEffects';
import { routeFileSelector } from '../../../utilz/i18n';
import FormSelectBox from '../Inputs/FormSelectBox';

const ShipmentCreatedBySelector = ({
  placeholder = '',
  label = '',
  rules = [],
  name,
  createdType = 1,
  margin,
  disabled,
  editMode,
  mode = 'single',
  tabIndex,
}) => {
  // 1->Name
  // 2->Email
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const { selectedCompany } = useSelector((state) => state.auth);

  useEffect(() => {
    if (selectedCompany?.companyId && createdType) getStatusList(selectedCompany.companyId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCompany, createdType]);

  const getStatusList = async (Customerkey) => {
    try {
      const payload = {
        Customerkey: Customerkey,
        CreatedByType: createdType,
      };
      setLoading(true);
      const { data } = await getShipmentCreatedBy(payload);
      const options = data.map((row) => ({
        label: row.createdByFullDesc,
        value: row.createdBy,
      }));
      setOptions(options);
      setLoading(false);
    } catch {
      setOptions([]);
      setLoading(false);
    }
  };

  return (
    <FormSelectBox
      loading={loading}
      options={options}
      placeholder={
        placeholder
          ? placeholder
          : createdType === 1
            ? t('translation:default.fields.userName.placeholder')
            : t('translation:default.fields.shipmentCreatedBy.email')
      }
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      disabled={disabled}
      editMode={editMode}
      mode={mode}
      tabIndex={tabIndex}
    />
  );
};

export default ShipmentCreatedBySelector;
